var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15268 0C3.21773 0 0 3.16933 0 7.07344C0 15.08 9.11034 19.2732 12.1831 21.8081L12.5761 22.1412L12.9692 21.8081C16.042 19.2732 25.1523 15.08 25.1523 7.07344C25.1523 3.16933 21.9346 0 17.9996 0C15.8135 0 13.8878 1.01154 12.5761 2.54722C11.2645 1.01154 9.33877 0 7.15268 0ZM7.15268 1.25402C9.20613 1.25402 10.9918 2.29005 12.0456 3.86002L12.5761 4.64378L13.1067 3.86002C14.1604 2.29005 15.9462 1.25402 17.9996 1.25402C21.2591 1.25402 23.8947 3.85267 23.8947 7.07344C23.8947 13.9069 16.1844 17.7375 12.5761 20.5541C8.96787 17.7375 1.25761 13.9069 1.25761 7.07344C1.25761 3.85267 3.89075 1.25402 7.15268 1.25402Z",
    fill: "#EE6D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69038 1.58144L1.05452 5.27165L0.527344 7.38034L1.05452 9.48903L2.10886 12.6521L4.21755 15.2879L7.38058 17.9238L10.5436 20.0325L12.6523 21.0868L13.7067 20.5596L17.924 17.3966L20.5599 15.2879L23.7229 11.5977L24.2501 8.43468V5.27165L22.1414 2.10862L18.4512 0.5271L14.761 1.58144L12.6523 3.69013L11.0708 2.10862L7.38058 0.5271L3.69038 1.58144Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToFavorites);
export default __webpack_public_path__ + "static/media/add-to-favorites.69cb84975a764ba5fac119f72acb3cdb.svg";
export { ForwardRef as ReactComponent };